export const UPLOAD_TARGETS = {
    'request-letter': {
        label: 'Surat permohonan',
        permission: 'order:create',
        prefix: 'request-letters',
        // A scan or a photo of one sheet. Anything larger is a mistake, not a letter.
        maxBytes: 8 * 1024 * 1024,
        contentTypes: ['application/pdf', 'image/jpeg', 'image/png', 'image/webp'],
    },
    'event-image': {
        label: 'Gambar kegiatan',
        permission: 'event:write',
        prefix: 'event-images',
        maxBytes: 4 * 1024 * 1024,
        contentTypes: ['image/jpeg', 'image/png', 'image/webp'],
    },
};
export const isUploadTarget = (v) => Object.prototype.hasOwnProperty.call(UPLOAD_TARGETS, v);
/**
 * Extension for a stored object, chosen from the CONTENT TYPE rather than from the
 * uploaded filename — a name is attacker-controlled and may carry no extension, two of
 * them, or a misleading one.
 */
const EXTENSIONS = {
    'application/pdf': 'pdf',
    'image/jpeg': 'jpg',
    'image/png': 'png',
    'image/webp': 'webp',
};
export const extensionFor = (contentType) => EXTENSIONS[contentType] ?? 'bin';
/** `accept` attribute for a file input, so the picker matches what the server allows. */
export const acceptFor = (t) => UPLOAD_TARGETS[t].contentTypes.join(',');
export function formatBytes(n) {
    if (n < 1024)
        return `${n} B`;
    if (n < 1024 * 1024)
        return `${(n / 1024).toFixed(0)} KB`;
    return `${(n / (1024 * 1024)).toFixed(1)} MB`;
}
